import { createFileRoute, Link } from '@tanstack/react-router';
import { z } from 'zod';
import { AuthShell } from '../components/AuthShell';
import { SetPasswordForm } from '../components/SetPasswordForm';

const resetSearchSchema = z.object({
  token: z.string().optional(),
});

export const Route = createFileRoute('/reset')({
  validateSearch: resetSearchSchema,
  component: ResetPage,
});

function ResetPage() {
  const { token } = Route.useSearch();

  if (!token || token.trim().length === 0) {
    return (
      <AuthShell
        tagline="Reset link missing."
        taglineSub="Request a new one to continue."
      >
        <h1 className="font-display text-3xl font-bold tracking-tight">
          Reset link is invalid
        </h1>
        <p className="mt-3 text-sm text-[color:var(--color-text-muted)]">
          The link you followed is missing the security token. Request a new reset
          email to continue.
        </p>
        <div className="mt-8 space-y-3">
          <Link
            to="/forgot"
            className="inline-flex items-center text-sm font-semibold text-gold-700 underline"
          >
            Request a new reset link
          </Link>
          <div>
            <Link
              to="/login"
              className="text-sm text-[color:var(--color-text-muted)] underline"
            >
              Back to sign in
            </Link>
          </div>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell
      tagline="Choose a new password."
      taglineSub="Make it strong and unique."
    >
      <SetPasswordForm token={token} mode="reset" />
    </AuthShell>
  );
}
